import {
    getNotificationIDMap,
    NextLessonIndicator,
} from "@utils/cap-notification-manager/cap-notification-process"
import { get } from "svelte/store"
import { notificationData } from "@utils/practice/notifications-data"
import { nextLessonInfo } from "@utils/practice/next-lesson"
import { NotificationManager } from "@utils/cap-notification-manager/cap-notification-manager"
import { goto } from "$app/navigation"
import { pendingOpenTask } from "../../routes/practice/Task.svelte"
import { awaitStoreTruthy } from "@utils/helpers/await-store"

export function lessonClickReceiver(lesson: number, id: number) {
    console.log(`Received lesson: ${lesson} with task ID ${id}`)
    const { map } = getNotificationIDMap(lesson)
    const at = map(id)
    if (!at) throw new Error(`Next lesson indicator not found for lesson ${lesson} with id ${id}}`)
    console.log(at)
    if (at instanceof NextLessonIndicator) {
        processNextLessonIndicator(at)
    } else {
        console.log("Received practice: ", at)
        pendingOpenTask.set(at)
        goto("/practice")
    }
}

async function processNextLessonIndicator(indicator: NextLessonIndicator) {
    console.log(`Processing next lesson dialogue (await notification data)...`)
    const notfData = await awaitStoreTruthy(notificationData, 1)
    console.log(`Processing complete!`)
    if (!notfData)
        throw new Error(`Next lesson indicator received but notification data was not set`)
    const live = get(notfData.live)
    // Time to go to next lesson
    const hypothetical = live.hypotheticalCurrentLesson
    if (hypothetical === null) {
        throw new Error(`Hypothetical lesson was null, clicked notification for lesson`)
    } else {
        console.log(`Hypothetical lesson found: ${hypothetical}`)
        if (hypothetical === indicator.nextLesson) {
            const lessonInfo = get(nextLessonInfo)
            if (!lessonInfo) throw new Error(`Next lesson info not registered`)
            lessonInfo.nextAction()
            goto("/practice")
        } else {
            throw new Error(
                `Hypothetical lesson ${hypothetical} was not the same as ${indicator.nextLesson}`,
            )
        }
    }
}

// @ts-expect-error test
globalThis.testLessonClickReceiver = lessonClickReceiver

NotificationManager.addListener("received", (ob) => {
    lessonClickReceiver(ob.lesson, ob.id)
})

NotificationManager.addListener("timezone", () => {
    console.log("timezone change initiated!")
    goto("/practice")
})

// // May come in handy! old code!

// /**
//  * DEPRECATED
//  * Listens for notification requests,
//  */
// const notificationListener : (notificationAction: ActionPerformed) => void = ({actionId, inputValue, notification : {extra}}) => {
//     console.log({actionId, inputValue, extra})
//     if (!extra) throw new Error("Notification did not have extra attached to it! Should never happen")
//     const {channel, lesson} = extra
//     if (channel === undefined) throw new Error("Channel was undefined! Should never happen")
//     if (lesson === undefined) throw new Error("Lesson was undefined! Should never happen")
//     switch(channel) {
//         case Channels.LESSON_REMINDER:
//             processReceivedNextLessonReminder(lesson+1)
//         break
//     }
// }

// isRegisteredForLessons.subscribe(registered => {
//     if (registered) {
//         LocalNotifications.addListener("localNotificationActionPerformed", notificationListener)
//     } else {
//         LocalNotifications.removeAllListeners()
//     }
// })

// /**
//  * Does next lesson and navigates to practice
//  * @param nextLesson the lesson that we want to go to
//  */
// async function processReceivedNextLessonReminder(nextLesson : number) {
//     const hyp = get(hypotheticalCurrentLesson)
//     if (hyp === null) {
//         console.warn("Hypothetical lesson was not set")
//         return
//     }
//     if (hyp !== nextLesson) {
//         console.warn("Hypothetical lesson not equal to next lesson - dismissing")
//     }
//     gotoNextLesson()
//     goto("/practice")
//     await refreshNotificationStore()
//     return
// }
